import React, {useImperativeHandle} from 'react';
import {useNavigate} from 'react-router-dom';
import {SharedByRefUrlNavigationApiRef} from '../../@types/SharedByRefUrlNavigationApi';

const SharedByRefUrlNavigationApi = React.forwardRef<SharedByRefUrlNavigationApiRef, { children: React.ReactNode }>((props, ref) => {
    const navigate = useNavigate();

    useImperativeHandle(ref, () => ({
        redirectTo: (url: string) => navigate(url),
    }));

    return <>{props.children}</>;
});

SharedByRefUrlNavigationApi.displayName = 'SharedByRefUrlNavigationApi';

export default SharedByRefUrlNavigationApi;
